import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { makePriceLabelRound } from "../../../utils/helpers/make-price-label";
import Trending from "./images/trending.svg";
import Shape from "./images/shape.svg";
import { dateFormatWithMonthDateYear } from "../../../utils/helpers/date-formatter";
import { PRICE_DROP_SOURCE } from "./constants";

const PriceDropCDPCard = ({content, source = PRICE_DROP_SOURCE.MSITE}) => {
    const {
        isPriceDrop,
        priceMeta: {
            updatedAt,
            priceDiff
        } = {}
    } = content || {};
    return (
        <div>
            {isPriceDrop &&
                <div styleName={source === PRICE_DROP_SOURCE.DESKTOP ? "styles.priceDropContainerDesktopVariant" : "styles.priceDropContainer"}>
                    {source === PRICE_DROP_SOURCE.MSITE ? <img src={Shape} /> : null}
                    <h1 styleName={"styles.heading"}>Price drop<img src={Trending} /></h1>
                    {priceDiff && <div styleName={"styles.savingSticker"}><p styleName={"styles.price"}>{makePriceLabelRound(priceDiff)} savings</p></div>}
                    {updatedAt ? (
                        <p styleName={"styles.subHeading"}>
                            Deal made sweeter on {dateFormatWithMonthDateYear(updatedAt)}. Get CARS24 Certified quality at our best-ever prices.
                        </p>
                    ) : (
                        <p styleName={"styles.subHeading"}>Don't miss out on extra savings with this special price.</p>
                    )}
                </div>}
        </div>
    );
};

PriceDropCDPCard.propTypes = {
    content: PropTypes.object,
    source: PropTypes.string
};

export default PriceDropCDPCard;
